import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'

/** The preview of a source table is fetched once and then cached. */
export const useHasSourceTablePreview = (sourceTableId: string | null) => {
  return useSelector((state: ApplicationState) =>
    sourceTableId ? sourceTableId in state.SourceTableStore.data : false
  )
}

/**
 * The cached preview payload. Typed by the caller — the rows are whatever the
 * source happens to contain.
 */
export const useSourceTablePreview = (sourceTableId: string | null) => {
  return useSelector((state: ApplicationState) =>
    sourceTableId ? state.SourceTableStore.data[sourceTableId] : undefined
  )
}
